import { defer, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { OrganizationUnitApiService } from '@core/api/services/organization-unit-api.service';
import { OrganizationUnitItem } from '@features/user/models/filter-data.model';

export function loadCommunityHierarchy(
  communityId: string,
  units: OrganizationUnitItem[],
  api: Pick<OrganizationUnitApiService, 'getById'>
): Observable<OrganizationUnitItem[]> {
  return defer(() => {
    const lookup = new Map(units.map(unit => [unit.id, unit]));
    const visited = new Set<string>();

    const visit = (id: string): Observable<OrganizationUnitItem[]> => {
      if (!id || visited.has(id)) return of([]);
      visited.add(id);
      const cached = lookup.get(id);
      const unit$: Observable<OrganizationUnitItem> = cached ? of(cached) : api.getById(id).pipe(map(dto => ({
        id: dto.id ?? id,
        name: dto.name ?? '',
        levelId: dto.organizationLevelId ?? 0,
        levelName: dto.levelName ?? '',
        parentId: dto.parentUnitId
      })));

      return unit$.pipe(
        switchMap(unit => {
          const current = unit.id !== communityId && unit.levelId >= 2 && unit.levelId <= 4 ? [unit] : [];
          return (unit.parentId && unit.levelId > 2 ? visit(unit.parentId) : of([])).pipe(
            map(parents => [...current, ...parents])
          );
        }),
        catchError(() => of([]))
      );
    };

    return visit(communityId);
  });
}
